import { connect } from "react-redux";
import PeoplePensionErrors from "@/integrations/peoplePension/contribution-errors-modal/ContributionErrorsModal";
import SmartPensionErrors from "@/integrations/smartPension/contribution-errors-modal/ContributionErrorsModal";

const PayPeriodModals = ({ integrationList }) => {
	return (
		<>
			{integrationList.includes("People's Pension") ? <PeoplePensionErrors /> : null}
			{integrationList.includes("Smart Pension") ? <SmartPensionErrors /> : null}
		</>
	);
};

const mapStateToProps = (state) => {
	const integrationList = Object.values({ ...state.integration })?.reduce((acc, integration) => {
		Object.values({ ...integration }).map((item) => {
			acc.push(item.name);
		});
		return acc;
	}, []);

	return {
		integrationList,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PayPeriodModals);
